let searchType = {
  hashtag: "hashtag",
  group: "group",
  user: "user",
  text: "text",
};
export { searchType };
